<template>
  <div>
    <v-dialog v-model="dialog" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          {{ $t("message.stand_by") }}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "LoadingDialog",
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    show(newValue) {
      this.dialog = newValue;
    }
  },
  data() {
    return {
      dialog: false
    };
  }
};
</script>

<style lang="scss" scoped></style>
